import { useFetchAttendanceReportQuery } from 'features/private-views/attendance-report/reportAttendanceApiSlice'
import moment from 'moment'
import { ChevronRight, Clock } from 'react-feather'
import { useNavigate, useOutletContext } from 'react-router-dom'
import { Card, CardBody, Spinner } from 'reactstrap'
import { COLOR_MAP } from 'config/templateConfig'

const SectionAttendanceWidget = ({ mode = 'secondary', params = {} }) => {
  const navigate = useNavigate()
  const profile = useOutletContext()

  const userId =
    profile?.data?.makerData?.userId || profile?.data?.ownerData?.userId

  const { data: attendanceData, isLoading } = useFetchAttendanceReportQuery({
    page: 0,
    size: 1,
    byUserId: userId,
  })

  // Mode Styling Configuration matching GenericLinkWidget
  let paddingClass = 'p-4'
  let titleClass = 'fw-bold mb-1'
  let iconSize = 24
  let iconPaddingClass = 'p-2 me-3'
  let descClass = 'mb-0'

  let isTinySquare = mode === 'tiny-square'
  let isTiny = mode === 'tiny' || isTinySquare

  if (mode === 'primary') {
    paddingClass = 'p-4'
    titleClass = 'fw-bold mb-1'
    iconSize = 36
    iconPaddingClass = 'p-3 me-3'
    descClass = 'mb-0'
  } else if (mode === 'compact') {
    paddingClass = 'p-3'
    titleClass = 'fw-bold mb-1'
    iconSize = 18
    iconPaddingClass = 'p-2 me-2'
    descClass = 'mb-0'
  } else if (isTiny) {
    paddingClass = isTinySquare ? 'p-2' : 'p-2 px-3'
    titleClass = `fw-bold mb-0 ${isTinySquare ? 'text-center' : 'text-start'}`
    iconSize = 16
    iconPaddingClass = 'p-2'
  }

  const items = attendanceData?.data?.items || attendanceData?.items || []
  const todayAttendance = items.length > 0 ? items[0] : null
  const checkInTime = todayAttendance?.checkIn
    ? moment(todayAttendance.checkIn).format('HH:mm')
    : '-'
  const checkOutTime = todayAttendance?.checkOut
    ? moment(todayAttendance.checkOut).format('HH:mm')
    : '-'

  const attendanceDate = todayAttendance?.checkIn || todayAttendance?.createdAt
  let subtitle = ''
  let dateText = ''

  if (attendanceDate) {
    const isToday = moment(attendanceDate).isSame(moment(), 'day')
    subtitle = isToday ? 'Kehadiran Hari Ini' : 'Riwayat Absensi Terakhir'
    dateText = moment(attendanceDate).locale('id').format('DD MMM YYYY')
  } else {
    subtitle = 'Belum ada absensi'
  }

  // Define accent colors
  const cardColor = COLOR_MAP[params.color] || '#2563EB'

  return (
    <div className={!isTiny ? 'h-100' : ''}>
      <Card
        onClick={() => {
          navigate('/attendance', {
            state: { autoSelectUserId: userId },
          })
        }}
        className={`${!isTiny ? 'h-100' : ''} border-0 shadow-sm transition-all`}
        style={{
          background: cardColor,
          backgroundImage: 'linear-gradient(135deg, rgba(255,255,255,0.15) 0%, rgba(0,0,0,0.05) 100%)',
          color: '#ffffff',
          border: 'none',
          cursor: 'pointer',
          transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
          aspectRatio: isTinySquare ? '1/1' : undefined,
          width: '100%',
          minHeight: isTinySquare ? undefined : mode === 'tiny' ? '68px' : mode === 'primary' ? '236px' : mode === 'compact' ? '110px' : '152px',
          borderRadius: isTiny ? '12px' : '20px',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: isTinySquare ? 'center' : 'flex-start',
          boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.transform = 'translateY(-5px)'
          e.currentTarget.style.boxShadow = '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)'
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.transform = 'translateY(0)'
          e.currentTarget.style.boxShadow = '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)'
        }}
      >
        <CardBody className={`${paddingClass} ${isTiny ? '' : 'flex-grow-1'} d-flex flex-column justify-content-center ${isTinySquare ? 'align-items-center justify-content-center text-center' : ''}`}>
          <div className={isTinySquare ? 'd-flex flex-column align-items-center justify-content-center mb-0 w-100' : `d-flex align-items-center w-100 ${mode === 'primary' ? 'mb-2' : 'mb-0'}`}>
            <div
              className={`${iconPaddingClass} ${isTinySquare ? 'mb-2' : 'me-3'} rounded-circle d-flex align-items-center justify-content-center`}
              style={{
                backgroundColor: 'rgba(255, 255, 255, 0.15)',
                backdropFilter: 'blur(8px)',
                border: '1px solid rgba(255, 255, 255, 0.2)',
                color: '#ffffff',
                border: 'none',
                flexShrink: 0,
                width: mode === 'primary' ? '64px' : (mode === 'compact' || isTiny) ? '36px' : '48px',
                height: mode === 'primary' ? '64px' : (mode === 'compact' || isTiny) ? '36px' : '48px',
                boxShadow: 'inset 0 0 10px rgba(255,255,255,0.1)'
              }}
            >
              <Clock size={iconSize} />
            </div>
            
            <div className={isTinySquare ? 'w-100' : 'flex-grow-1 d-flex flex-column justify-content-center'}>
              <div
                className={`${titleClass} ${isTiny ? 'd-block text-truncate' : 'text-truncate'}`}
                style={{ 
                  color: '#ffffff', 
                  fontSize: isTiny ? '14px' : mode === 'primary' ? '28px' : mode === 'compact' ? '15px' : '18px',
                  fontWeight: 600,
                  marginBottom: !isTiny ? '2px' : '0',
                  lineHeight: 1.1
                }}
              >
                Absensi
              </div>
              
              {isTiny && (
                <div className={`text-white-50 ${isTinySquare ? 'text-center' : 'text-start'}`} style={{ fontSize: 13, alignSelf: isTinySquare ? 'center' : 'flex-start' }}>
                  Check In: {checkInTime}
                </div>
              )}
              
              {!isTiny && (
                <div className="small d-flex align-items-center" style={{ color: 'rgba(255,255,255,0.7)', fontSize: mode === 'compact' ? '11px' : '12px', marginTop: mode === 'primary' ? '4px' : '2px' }}>
                  <ChevronRight size={10} className="me-1" />
                  <span>Lihat Detail Absensi</span>
                </div>
              )}
            </div>
          </div>

          {!isTiny && (
            <div className="mt-2" style={{ color: 'rgba(255,255,255,0.7)', fontSize: mode === 'compact' ? '12px' : '14px', lineHeight: '1.4' }}>
              {isLoading ? (
                <div className="d-flex mt-1">
                  <Spinner size="sm" color="light" />
                </div>
              ) : attendanceDate ? (
                <div className={`d-flex flex-column ${mode==='compact'?'gap-0':'gap-1'}`}>
                  <span>{subtitle} {dateText && mode !== 'compact' && `(${dateText})`}</span>
                  <div className="d-flex align-items-center gap-3 mt-1">
                    <div className="d-flex flex-column">
                      <span style={{ color: 'rgba(255,255,255,0.7)', fontSize: mode === 'compact' ? 10 : 11 }}>Check In</span>
                      <span className="text-white fw-semibold">{checkInTime}</span>
                    </div>
                    <div className="d-flex flex-column">
                      <span style={{ color: 'rgba(255,255,255,0.7)', fontSize: mode === 'compact' ? 10 : 11 }}>Check Out</span>
                      <span className="text-white fw-semibold">{checkOutTime}</span>
                    </div>
                  </div>
                </div>
              ) : (
                <span>{subtitle}</span>
              )}
            </div>
          )}
        </CardBody>
      </Card>
    </div>
  )
}

export default SectionAttendanceWidget
